import { Cpu, Gauge, Stethoscope, Filter, Wind, Droplets, Search } from "lucide-react";
import { Reveal } from "./Reveal";

const SERVICES = [
  { icon: Cpu, title: "Stage 1, 2 & 3", sub: "ECU Remapping", desc: "Tailored remaps unlocking your engine's true potential, safely." },
  { icon: Gauge, title: "Performance & Economy", sub: "Tuning", desc: "Dial in for raw power or maximum MPG — your drive, your choice." },
  { icon: Stethoscope, title: "Vehicle", sub: "Diagnostics", desc: "Deep system scans to read, decode and clear every fault code." },
  { icon: Filter, title: "DPF", sub: "Services", desc: "Diesel particulate filter cleaning, regeneration and solutions." },
  { icon: Wind, title: "EGR", sub: "Services", desc: "Exhaust gas recirculation servicing for smoother, cleaner running." },
  { icon: Droplets, title: "AdBlue", sub: "Services", desc: "AdBlue system servicing and fault resolution done properly." },
  { icon: Search, title: "Fault", sub: "Finding", desc: "Pinpoint diagnostics to track down and fix stubborn issues." },
];

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative bg-brand-charcoal py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="flex items-center gap-3 text-brand-red font-semibold uppercase tracking-[0.35em] text-xs sm:text-sm mb-5">
            <span className="h-px w-10 bg-brand-red" /> What We Do
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display italic font-extrabold uppercase tracking-tight text-white text-5xl sm:text-6xl md:text-7xl leading-[0.9] max-w-3xl">
            Our <span className="text-brand-red">Services</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-brand-line border border-brand-line">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title + s.sub} delay={(i % 3) * 0.08} className="h-full">
                <div
                  data-testid={`service-card-${i}`}
                  className="group relative h-full bg-brand-charcoal2 hover:bg-brand-charcoal3 p-8 md:p-10 transition-colors duration-300 overflow-hidden"
                >
                  <span className="pointer-events-none absolute left-0 top-0 h-full w-[3px] bg-brand-red scale-y-0 group-hover:scale-y-100 origin-top transition-transform duration-300" />
                  <span className="font-display italic font-black text-6xl text-white/[0.04] absolute top-4 right-5 select-none">
                    0{i + 1}
                  </span>
                  <Icon className="text-brand-red mb-6 transition-transform duration-300 group-hover:-translate-y-1" size={34} strokeWidth={1.6} />
                  <h3 className="font-display italic font-bold uppercase tracking-tight text-white leading-none text-3xl md:text-[2rem] group-hover:text-glow-red transition-[text-shadow] duration-300">
                    {s.title}
                    <span className="block text-brand-grey text-xl md:text-2xl mt-1 group-hover:text-brand-offwhite transition-colors">{s.sub}</span>
                  </h3>
                  <p className="mt-5 text-sm text-brand-offwhite/60 leading-relaxed max-w-xs">{s.desc}</p>
                </div>
              </Reveal>
            );
          })}

          {/* Filler cell to complete the 8th grid slot on large screens */}
          <Reveal delay={0.16} className="h-full">
            <div className="h-full min-h-[220px] bg-brand-charcoal2 p-8 md:p-10 flex flex-col justify-center">
              <p className="font-display italic font-bold uppercase text-2xl md:text-3xl text-white leading-none">
                Not sure what<br />you need?
              </p>
              <a
                href="#contact"
                data-testid="services-ask-btn"
                className="mt-5 inline-flex w-fit items-center gap-2 text-brand-red font-semibold uppercase tracking-wider text-sm hover:text-brand-redhover transition-colors"
              >
                Just ask us →
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
